<template>
  <div class="card">
    <div class="card-body">
      <Survey v-if="view === 'survey'" :survey="survey" @done="handleSurveyDone" />
      <Subscribe
        v-else-if="view === 'subscribe'"
        :survey-id="survey.id"
        :list-id="survey.list"
        :estimated-price="estimatedPrice"
        :subscribe-post-url="subscribePostUrl"
        @done="handleSubcriptionDone"
      />
      <CallToAction
        v-else-if="view === 'call-to-action'"
        :survey="survey"
        :cta-callback="ctaCallback"
        :reassurances="reassurances"
      />
    </div>
  </div>
</template>

<script>
import reduce from 'lodash/reduce'

import Survey from './components/Survey.vue'
import Subscribe from './components/Subscribe.vue'
import CallToAction from './components/CallToAction.vue'

export default {
  name: 'HowMuch',
  components: {
    Survey,
    Subscribe,
    CallToAction
  },
  props: {
    survey: {
      type: Object,
      required: true
    },
    subscribePostUrl: {
      type: String,
      required: true
    },
    ctaCallback: {
      type: Function,
      required: true
    },
    reassurances: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      view: 'survey',
      responses: []
    }
  },
  computed: {
    estimatedPrice() {
      return reduce(
        this.responses,
        (sum, response) => {
          return sum + response.answer.estimatedPrice
        },
        0
      )
    }
  },
  methods: {
    handleSurveyDone(responses) {
      this.responses = responses
      this.view = 'subscribe'
    },
    handleSubcriptionDone() {
      this.view = 'call-to-action'
    }
  }
}
</script>
